import http from "../plugins/axios";
import { AxiosError } from "axios";
import { client_id, authorize_uri, redirect_uri } from "../config/login"
import session from "../store/session"
import { loginSuccess } from "../store/user";
import reduxStore from "../store";
export interface LoginOauthForm {
  code: string;
  type: 1 | 2 | 3; // 1 2 3 for different pair of key
}

interface LoginResponse {
  token: string;
}


export function loginOauthApi(form: LoginOauthForm): Promise<{
  success: boolean,
  token: string
}> {
  return new Promise((resolve, reject) => {
    http
      .post("/api/user/loginoauth", form)
      .then((response) => {
        return resolve({
          success: true,
          token: (response.data as LoginResponse).token
        })
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403 || status === 401)
            return reject("form-not-accept");
          if (status === 405) return reject("user-blocked");
          else if (status === 418) return resolve({
            success: false,
            token: error.response?.data
          });
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}


export const login = (curAddress: string) => {
  if (!session.key) {
    //console.log({ client_id, authorize_uri, redirect_uri })
    var href = `${authorize_uri}?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code&state=${encodeURIComponent(
      curAddress
    )}`;
    //console.log(`oauth submit: ${href}`);
    window.location.href = href;
  } else {
    reduxStore.dispatch(loginSuccess(session.key));
  }
};
